import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";
import { isPrivatePath } from "@/lib/private-prefixes";

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

const ROBOTS_HEADER = "noindex, nofollow, noarchive, nosnippet";

const privateRobotsMiddleware = createMiddleware().server(async ({ next, request }) => {
  const result = await next();
  if (!isPrivatePath(new URL(request.url).pathname)) return result;
  const res = (result as any)?.response ?? result;
  if (!(res instanceof Response)) return result;
  try {
    res.headers.set("X-Robots-Tag", ROBOTS_HEADER);
    return result;
  } catch {
    const headers = new Headers(res.headers);
    headers.set("X-Robots-Tag", ROBOTS_HEADER);
    const copy = new Response(res.body, { status: res.status, statusText: res.statusText, headers });
    return (result as any)?.response ? { ...(result as any), response: copy } : (copy as any);
  }
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [errorMiddleware, privateRobotsMiddleware],
}));
